<td>
</td>
<tr style="border-bottom: 2px solid black;">
  <td colspan="100%"></td>
</tr>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td>
  @if (cliente.solicitudesCrediticias[0]?.excedido){
    <div class="fondo mt-2">
      <p style="margin: 0;">${{cliente.solicitudesCrediticias[0]?.excedido?.monto | number: '1.0-0'}}</p>
      <span class="fondo fecha">
                        {{cliente.solicitudesCrediticias[0]?.excedido?.fechaDesde | date: 'dd/MM/yyyy'}} - {{cliente.solicitudesCrediticias[0]?.excedido?.fechaHasta | date: 'dd/MM/yyyy'}}
                      </span>
    </div>
  } @else if (cliente.solicitudesCrediticias[1]?.excedido){
    <div class="fondo mt-2">
      <p style="margin: 0;">${{cliente.solicitudesCrediticias[1]?.excedido?.monto | number: '1.0-0'}}</p>
      <span class="fondo fecha">
                        {{cliente.solicitudesCrediticias[1]?.excedido?.fechaDesde | date: 'dd/MM/yyyy'}} - {{cliente.solicitudesCrediticias[1]?.excedido?.fechaHasta | date: 'dd/MM/yyyy'}}
                      </span>
    </div>
  }
</td>
<td>
  @if (cliente.solicitudesCrediticias[0]?.excedido){
    <div class="fondo">
      <p style="margin: 0;">${{cliente.situacionExcedido - cliente.solicitudesCrediticias[0]?.excedido?.monto  | number: '1.0-0'}}</p>
    </div>
  } @else if (cliente.solicitudesCrediticias[1]?.excedido){
    <div class="fondo">
      <p style="margin: 0;">${{cliente.situacionExcedido - cliente.solicitudesCrediticias[1]?.excedido?.monto | number: '1.0-0'}}</p>
    </div>
  }
</td>
<td></td>
<td>
  @if (cliente.solicitudesCrediticias[0]?.vencido){
    <div class="fondo mt-2">
      <p style="margin: 0;">${{cliente.solicitudesCrediticias[0]?.vencido?.monto | number: '1.0-0'}}</p>
      <span class="fondo fecha">
                        {{cliente.solicitudesCrediticias[0]?.vencido?.fechaDesde | date: 'dd/MM/yyyy'}} - {{cliente.solicitudesCrediticias[0]?.vencido?.fechaHasta | date: 'dd/MM/yyyy'}}
                      </span>
    </div>
  } @else if (cliente.solicitudesCrediticias[1]?.vencido){
    <div class="fondo mt-2">
      <p style="margin: 0;">${{cliente.solicitudesCrediticias[1]?.vencido?.monto | number: '1.0-0'}}</p>
      <span class="fondo fecha">
                        {{cliente.solicitudesCrediticias[1]?.vencido?.fechaDesde | date: 'dd/MM/yyyy'}} - {{cliente.solicitudesCrediticias[1]?.vencido?.fechaHasta | date: 'dd/MM/yyyy'}}
                      </span>
    </div>
  }
</td>
<td>
  @if (cliente.solicitudesCrediticias[0]?.vencido){
    <div class="fondo">
      <p style="margin: 0;">${{cliente.situacionVencido - cliente.solicitudesCrediticias[0]?.vencido?.monto | number: '1.0-0'}}</p>
    </div>
  } @else if (cliente.solicitudesCrediticias[1]?.vencido){
    <div class="fondo">
      <p style="margin: 0;">${{cliente.situacionVencido - cliente.solicitudesCrediticias[1]?.vencido?.monto | number: '1.0-0'}}</p>
    </div>
  }
</td>
<td>
  <div style="justify-content: center" class="d-flex align-items-center text-primary fondo">
    <input type="checkbox" [disabled]="bloquear" [checked]="checkArray.includes(cliente.clienteId)" (change)="checkSelected(cliente)" id="estadoSolicitud">
  </div>
</td>
